'use strict';
import React, { Component } from 'react'
var FormatMessage = require('react-globalize').FormatMessage;

export default class Prevent extends Component {

  constructor(props) {
    super(props);
  }

  render () {
    return (
      <div className="container">
        <div className="row text-justify">

          {
            this.props.locale == "es" ?
            <div className="col-md-12" style={{padding:25}}>
              <div className="row">
                <div className="col-md-6">
                  <p>
                    Si un estafador se ha puesto en contacto con usted, ya sea que haya perdido 
                    dinero o no, es útil presentar una queja. Los grupos que responden a estos 
                    delitos incluyen el Better Business Bureau, la &nbsp; 
                    <a target="_blank" href="https://www.ftc.gov/">Comisión Federal de Comercio</a>&nbsp;
                    y el &nbsp;<a target="_blank" href="https://www.ic3.gov/">Centro de Quejas de Delitos en 
                    Internet del FBI</a>.
                  </p>
                  <p>
                    Si ha perdido dinero en una estafa, es posible comunicarse con su banco o 
                    compañía de tarjeta de crédito/débito y pedirles que anulen el pago. Sin 
                    embargo, es más difícil recuperar los fondos con estafas que utilizan 
                    tarjetas de regalo o transferencias bancarias.
                  </p>
                  <p>
                    Si fue víctima de una estafa, es posible que otras personas o grupos intenten 
                    comunicarse con usted nuevamente, así que no envíe dinero a nadie más que llame 
                    con una historia sospechosa similar. También debe continuar informando estos 
                    intentos de fraude a las autoridades correspondientes.
                  </p>
                  <p>
                    También puede agregar su número de teléfono al &nbsp;<a target="_blank" 
                    href="https://www.donotcall.gov/">Registro Nacional No Llame</a>.&nbsp; 
                    Esta lista se creó en 2003 para responder a un número creciente de empresas de 
                    venta directa que obstruyen las líneas telefónicas de las personas. Las llamadas 
                    automáticas a menudo ignoran si estás o no en esta lista, pero aun así puede ser 
                    un buen primer paso para reducir este tipo de llamadas.
                  </p>
                </div>
                <div className="col-md-6">
                  <div>
                    <p>
                      <b>Para reportar:</b>
                      <br/>
                      <b>Localizador de cuidado de ancianos 1-800-677-1116</b>
                      <br/>
                      <b>Línea Directa Nacional de Fraude de Ancianos 833–372–8311</b>
                    </p>
                    <p>
                      <ul>
                        <li><a href='https://eldercare.acl.gov/Public/Index.aspx' target='_blank'>https://eldercare.acl.gov/Public/Index.aspx</a></li>
                        <li><a href='https://ncea.acl.gov/Resources/State.aspx' target='_blank'>https://ncea.acl.gov/Resources/State.aspx</a></li>
                        <li><a href='https://www.cdss.ca.gov/inforesources/adult-protective-services' target='_blank'>https://www.cdss.ca.gov/inforesources/adult-protective-services</a></li>
                        <li><a href='http://www.corruptionmaps.com/adult-protective-services-reporting-state/#:~:text=Adult%20Protective%20Services%20Reporting%20By%20State%201%20State,7%20Colorado%20...%208%20Connecticut%20...%20More%20items' target='_blank'>Informes de servicios de protección para adultos por estado - VP Task Force ™ - CSM (corruptionmaps.com)</a></li>
                        <li><a href='https://www.justice.gov/elderjustice/find-support-elder-abuse' target='_blank'>https://www.justice.gov/elderjustice/find-support-elder-abuse</a></li>
                        <li><a href='https://dfpi.ca.gov/preventing-and-reporting-elder-financial-abuse/' target='_blank'>Prevención y denuncia del abuso financiero de personas mayores | El Departamento de Protección Financiera e Innovación (ca.gov)</a></li>
                        <li><a href='https://www.fdic.gov/consumers/consumer/news/cnwin1112/elderfraud.html' target='_blank'>FDIC: FDIC Consumer News Winter 2011/2012 - Fraude contra los ancianos: cómo puede detectar y prevenir el abuso financiero</a></li>
                        <li><a href='https://www.consumeraffairs.com/finance/elderly-financial-scam-statistics.html#online-shopping-scams' target='_blank'>Estadísticas de abuso financiero de ancianos 2022: Estafas y fraudes comunes | Asuntos del Consumidor</a></li>
                        <li><a href='https://www.consumerfinance.gov/consumer-tools/educator-tools/resources-for-older-adults/reporting-elder-financial-abuse-guide/' target='_blank'>Reportar abuso financiero de ancianos | Oficina de Protección Financiera del Consumidor (consumerfinance.gov)</a></li>
                        <li><a href='https://www.justice.gov/archives/stopfraud-archive/report-financial-fraud' target='_blank'>StopFraud.gov - Reportar fraude financiero (justice.gov)</a></li>
                        <li><a href='https://reportfraud.ftc.gov/#/' target='_blank'>ReportFraud.ftc.gov</a></li>
                        <li><a href='https://www.justice.gov/elderjustice/roadmap' target='_blank'>Mapa de ruta de recursos para el abuso de ancianos - Financiero | EJE | Departamento de Justicia</a></li>
                        <li><a href='https://ovc.ojp.gov/program/stop-elder-fraud/providing-help-restoring-hope' target='_blank'>Línea Directa Nacional de Fraude de Ancianos | Oficina para Víctimas del Delito (ojp.gov)</a></li>
                        <li><a href='https://dfpi.ca.gov/wp-content/uploads/sites/337/2019/04/Protect_Yourself_From_Fraud_ES.pdf?emrc=78c26e' target='_blank'>Protéjase Del Fraude (ca.gov)</a></li>
                        <li><a href='https://dfpi.ca.gov/wp-content/uploads/sites/337/2019/07/Abuso-financiero-a-las-personas-de-la-tercera-edad-ADA.pdf' target='_blank'>Abuso financiero a las personas de la tercera edad (ca.gov)</a></li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div>
            </div> 
            
            :
            
            <div className="col-md-12" style={{padding:25}}>
              <div className="row">
                <div className="col-md-6">
                  <p>
                    If you’ve been contacted by a fraudster, whether or not you’ve lost money, 
                    it’s helpful to file a complaint. Groups that respond to these crimes include 
                    the Better Business Bureau, the <a target="_blank" href="https://www.ftc.gov/">
                    Federal Trade Commission</a> and the <a target="_blank" href="https://www.ic3.gov/">
                    FBI’s Internet Crime Complaint Center</a>.
                  </p>
                  <p>
                    If you’ve lost money to a scam, it’s possible to contact your bank or credit/debit 
                    card company and ask them to void the payment. However, it’s harder to recover the 
                    funds with scams that utilize gift cards or wire transfers.
                  </p>
                  <p>
                    If you were a victim of a scam, other individuals or groups might try to contact 
                    you again, so don’t send money to anyone else calling with a similar suspicious 
                    story. You should continue to report these fraud attempts to the appropriate 
                    authorities, too.
                  </p>
                  <p>
                    You can also add your phone number to the <a target="_blank" href='https://www.donotcall.gov/'>
                    National Do Not Call Registry</a>. This list was created in 2003 to respond to a growing 
                    number of direct-sales companies clogging up people’s phone lines. Robocallers often ignore 
                    whether or not you’re on this list, but it can still be a good first step for reducing these 
                    types of calls.
                  </p>
                </div>
                <div className="col-md-6">
                  <div>
                    <p>
                      <b>To report:</b>
                      <br/>
                      <b>Eldercare locator  1-800-677-1116</b>
                      <br/>
                      <b>National Elder Fraud Hotline 833–372–8311</b>
                    </p>
                    <p>
                      <ul>
                        <li><a href='https://eldercare.acl.gov/Public/Index.aspx' target='_blank'>https://eldercare.acl.gov/Public/Index.aspx</a></li>
                        <li><a href='https://ncea.acl.gov/Resources/State.aspx' target='_blank'>https://ncea.acl.gov/Resources/State.aspx</a></li>
                        <li><a href='https://www.cdss.ca.gov/inforesources/adult-protective-services' target='_blank'>https://www.cdss.ca.gov/inforesources/adult-protective-services</a></li>
                        <li><a href='http://www.corruptionmaps.com/adult-protective-services-reporting-state/#:~:text=Adult%20Protective%20Services%20Reporting%20By%20State%201%20State,7%20Colorado%20...%208%20Connecticut%20...%20More%20items' target='_blank'>Adult Protective Services Reporting By State – VP Task Force ™ – CSM (corruptionmaps.com)</a></li>
                        <li><a href='https://www.justice.gov/elderjustice/find-support-elder-abuse' target='_blank'>https://www.justice.gov/elderjustice/find-support-elder-abuse</a></li>
                        <li><a href='https://dfpi.ca.gov/preventing-and-reporting-elder-financial-abuse/' target='_blank'>Preventing and Reporting Elder Financial Abuse | The Department of Financial Protection and Innovation (ca.gov)</a></li>
                        <li><a href='https://www.fdic.gov/consumers/consumer/news/cnwin1112/elderfraud.html' target='_blank'>FDIC: FDIC Consumer News Winter 2011/2012 - Fraud Against the Elderly: How You Can Spot and Prevent Financial Abuse</a></li>
                        <li><a href='https://www.consumeraffairs.com/finance/elderly-financial-scam-statistics.html#online-shopping-scams' target='_blank'>Elder Financial Abuse Statistics 2022: Common Scams & Frauds | ConsumerAffairs</a></li>
                        <li><a href='https://www.consumerfinance.gov/consumer-tools/educator-tools/resources-for-older-adults/reporting-elder-financial-abuse-guide/' target='_blank'>Reporting elder financial abuse | Consumer Financial Protection Bureau (consumerfinance.gov)</a></li>
                        <li><a href='https://www.justice.gov/archives/stopfraud-archive/report-financial-fraud' target='_blank'>StopFraud.gov - Report Financial Fraud (justice.gov)</a></li>
                        <li><a href='https://reportfraud.ftc.gov/#/' target='_blank'>ReportFraud.ftc.gov</a></li>
                        <li><a href='https://www.justice.gov/elderjustice/roadmap' target='_blank'>Elder Abuse Resource Roadmap - Financial | EJI | Department of Justice</a></li>
                        <li><a href='https://ovc.ojp.gov/program/stop-elder-fraud/providing-help-restoring-hope' target='_blank'>National Elder Fraud Hotline | Office for Victims of Crime (ojp.gov)</a></li>
                        <li><a href='https://dfpi.ca.gov/wp-content/uploads/sites/337/2019/04/Protect_Yourself_From_Fraud_ES.pdf?emrc=78c26e' target='_blank'>Protect Yourself From Fraud (ca.gov)</a></li>
                        <li><a href='https://dfpi.ca.gov/wp-content/uploads/sites/337/2019/07/Abuso-financiero-a-las-personas-de-la-tercera-edad-ADA.pdf' target='_blank'>Financial abuse of elderly people (ca.gov)</a></li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
          }
        </div>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./js/elderAbuseContent/Prevent.js